const translations = {
  el: {
    services: "Υπηρεσίες",
    about: "Σχετικά",
    contact: "Επικοινωνία",
    privacy: "Προστασία Δεδομένων",
    nav_cta: "Δωρεάν Συμβουλευτική",

    works: "Έργα",
    works_label: "Portfolio",
    works_title: "Ολοκληρωμένα Έργα",
    works_subtitle: "Πραγματικές εφαρμογές που έχουμε σχεδιάσει, αναπτύξει και κυκλοφορήσει για πελάτες μας.",
    works_badge: "Live",
    works_project1_name: "Δρ. Αθ. Μουσιώλης",
    works_project1_desc: "Επίσημη εφαρμογή iOS για παρακολούθηση γυναικείας υγείας, γονιμότητας και κύησης, με άμεση πρόσβαση σε ιατρική πληροφόρηση και χρήσιμες ειδοποιήσεις.",
    works_project1_cta: "Δείτε στο App Store",
    works_project2_name: "Δρ. Αθ. Μουσιώλης, Γυναικολόγος (Android)",
    works_project2_desc: "Επίσημη εφαρμογή Android παρακολούθησης γυναικείας υγείας, γονιμότητας και κύησης με χρήσιμες ειδοποιήσεις και αξιόπιστη ενημέρωση.",
    works_project2_cta: "Δείτε στο Google Play",
    works_project3_name: "Σύστημα Διαχείρισης Αερολέσχης Ν. Καρδίτσας",
    works_project3_desc: "Web σύστημα διαχείρισης για την Αερολέσχη Ν. Καρδίτσας, σχεδιασμένο για αποτελεσματική οργάνωση λειτουργιών, με ασφαλή πρόσβαση και online παρουσία.",
    works_project3_cta: "Επισκεφθείτε το έργο",

    hero_title: "Αναβαθμίστε την Επιχείρησή σας με Custom Λύσεις Τεχνητής Νοημοσύνης",
    hero_tagline: "Αυτοματοποιήστε διαδικασίες, μειώστε το κόστος και αυξήστε την παραγωγικότητα της ομάδας σας έως και 60% — με AI λύσεις σχεδιασμένες αποκλειστικά για την επιχείρησή σας.",
    hero_cta_btn: "Κλείστε μια Δωρεάν Συμβουλευτική",
    hero_btn: "Δείτε τις Υπηρεσίες μας",

    services_title: "Οι Υπηρεσίες μας",
    service1_title: "Κατασκευή Ιστοσελίδων",
    service1_desc: "Σύγχρονες web εφαρμογές υψηλής απόδοσης, βελτιστοποιημένες για SEO και conversions.",
    service1_usecase: "Παράδειγμα: Εταιρεία logistics αύξησε τις online παραγγελίες κατά 45% μετά από ανακατασκευή του site με AI-driven personalization.",
    service2_title: "Mobile Apps",
    service2_desc: "Εφαρμογές για Android και iOS που απλοποιούν τη ροή εργασίας και βελτιώνουν την εμπειρία πελατών.",
    service2_usecase: "Παράδειγμα: Αλυσίδα καταστημάτων μείωσε τον χρόνο εξυπηρέτησης κατά 30% με custom mobile app για το προσωπικό.",
    service3_title: "Αυτοματοποίηση Διαδικασιών",
    service3_desc: "Αυτοματοποίηση επαναλαμβανόμενων εργασιών με AI και IoT, ώστε η ομάδα σας να εστιάζει σε αυτό που μετράει.",
    service3_usecase: "Παράδειγμα: Βιομηχανική μονάδα εξάλειψε 80% των χειροκίνητων ελέγχων ποιότητας με αυτοματοποιημένη Computer Vision.",
    service4_title: "Τεχνητή Νοημοσύνη",
    service4_desc: "Machine Learning, NLP και predictive analytics για έξυπνες αποφάσεις βασισμένες σε δεδομένα.",
    service4_usecase: "Παράδειγμα: Επιχείρηση e-commerce αύξησε τις πωλήσεις κατά 35% με AI σύστημα προτάσεων προϊόντων.",

    about_title: "Σχετικά με την KLEOS",
    about_text: "Είμαστε μία καινοτόμα εταιρία τεχνολογίας που ειδικεύεται στην ανάπτυξη σύγχρονων web και mobile εφαρμογών, στην τεχνητή νοημοσύνη και σε αυτόνομα συστήματα.",

    contact_title: "Επικοινωνία",
    contact_description: "Επικοινωνήστε μαζί μας για να συζητήσουμε πώς μπορούμε να βοηθήσουμε την επιχείρησή σας να αναπτυχθεί με τις τεχνολογικές λύσεις μας.",
    contact_name: "Όνομα",
    contact_email: "Email",
    contact_message: "Μήνυμα",
    contact_send: "Αποστολή",
    contact_sending: "Αποστολή...",
    contact_success: "Το μήνυμά σας εστάλη με επιτυχία!",
    contact_error: "Υπήρξε πρόβλημα με την αποστολή. Παρακαλώ προσπαθήστε ξανά.",

    privacy_title: "Πολιτική Προστασίας Προσωπικών Δεδομένων",
    privacy_intro: "Η KLEOS AI δεσμεύεται για την προστασία των προσωπικών σας δεδομένων και την τήρηση του Γενικού Κανονισμού Προστασίας Δεδομένων (GDPR).",
    privacy_collection_title: "Συλλογή Δεδομένων",
    privacy_collection_text: "Συλλέγουμε προσωπικά δεδομένα μόνο όταν τα παρέχετε εθελοντικά μέσω της φόρμας επικοινωνίας μας. Αυτά περιλαμβάνουν το όνομά σας, τη διεύθυνση email σας και το μήνυμά σας.",
    privacy_use_title: "Χρήση Δεδομένων",
    privacy_use_text: "Χρησιμοποιούμε τα δεδομένα σας αποκλειστικά για να απαντήσουμε στα ερωτήματά σας και να παρέχουμε τις υπηρεσίες που ζητάτε. Δεν μοιραζόμαστε τα δεδομένα σας με τρίτους χωρίς τη συγκατάθεσή σας.",
    privacy_rights_title: "Τα Δικαιώματά σας",
    privacy_rights_text: "Έχετε το δικαίωμα πρόσβασης, διόρθωσης, διαγραφής και φορητότητας των δεδομένων σας. Μπορείτε επίσης να αντιταχθείτε στην επεξεργασία των δεδομένων σας. Για να ασκήσετε αυτά τα δικαιώματα, επικοινωνήστε μαζί μας.",
    privacy_contact_title: "Επικοινωνία",
    privacy_contact_text: "Για οποιεσδήποτε ερωτήσεις σχετικά με την προστασία των δεδομένων, επικοινωνήστε μαζί μας στο info@kleos-ai.gr"
  },

  en: {
    services: "Services",
    about: "About",
    contact: "Contact",
    privacy: "Privacy Policy",
    nav_cta: "Free Consultation",

    works: "Works",
    works_label: "Portfolio",
    works_title: "Completed Projects",
    works_subtitle: "Real applications we have designed, developed, and launched for our clients.",
    works_badge: "Live",
    works_project1_name: "Dr. Ath. Moussiolis",
    works_project1_desc: "Official iOS app for women's health, fertility, and pregnancy monitoring, with direct access to trusted medical information and useful reminders.",
    works_project1_cta: "View on the App Store",
    works_project2_name: "Dr. Ath. Moussiolis, Gynecologist (Android)",
    works_project2_desc: "Official Android app for women's health, fertility, and pregnancy monitoring, with useful reminders and reliable medical information.",
    works_project2_cta: "View on Google Play",
    works_project3_name: "Aeroclub of Karditsa Management System",
    works_project3_desc: "Web-based management system for the Aeroclub of Karditsa, built for efficient operations, secure access, and a modern online presence.",
    works_project3_cta: "Visit project",

    hero_title: "Upgrade Your Business with Custom AI Solutions",
    hero_tagline: "Automate processes, cut costs, and boost your team's productivity by up to 60% — with AI solutions designed exclusively for your business.",
    hero_cta_btn: "Book a Free Consultation",
    hero_btn: "See our Services",

    services_title: "Our Services",
    service1_title: "Web Development",
    service1_desc: "Modern high-performance web applications, optimized for SEO and conversions.",
    service1_usecase: "Example: A logistics company increased online orders by 45% after rebuilding their site with AI-driven personalization.",
    service2_title: "Mobile Apps",
    service2_desc: "Android and iOS apps that streamline workflows and improve customer experience.",
    service2_usecase: "Example: A retail chain reduced service time by 30% with a custom mobile app for staff.",
    service3_title: "Process Automation",
    service3_desc: "Automate repetitive tasks with AI and IoT, so your team can focus on what matters.",
    service3_usecase: "Example: A manufacturing unit eliminated 80% of manual quality checks with automated Computer Vision.",
    service4_title: "Artificial Intelligence",
    service4_desc: "Machine Learning, NLP and predictive analytics for smart, data-driven decisions.",
    service4_usecase: "Example: An e-commerce business increased sales by 35% with an AI product recommendation system.",

    about_title: "About KLEOS",
    about_text: "We are an innovative technology company specialized in developing modern web and mobile applications, artificial intelligence, and autonomous systems.",

    contact_title: "Contact",
    contact_description: "Get in touch with us to discuss how we can help your business grow with our technological solutions.",
    contact_name: "Name",
    contact_email: "Email",
    contact_message: "Message",
    contact_send: "Send",
    contact_sending: "Sending...",
    contact_success: "Your message has been sent successfully!",
    contact_error: "There was a problem sending your message. Please try again.",

    privacy_title: "Privacy Policy",
    privacy_intro: "KLEOS AI is committed to protecting your personal data and complying with the General Data Protection Regulation (GDPR).",
    privacy_collection_title: "Data Collection",
    privacy_collection_text: "We collect personal data only when you voluntarily provide it through our contact form. This includes your name, email address, and your message.",
    privacy_use_title: "Data Usage",
    privacy_use_text: "We use your data exclusively to respond to your inquiries and provide the services you request. We do not share your data with third parties without your consent.",
    privacy_rights_title: "Your Rights",
    privacy_rights_text: "You have the right to access, correct, delete, and port your data. You can also object to the processing of your data. To exercise these rights, please contact us.",
    privacy_contact_title: "Contact",
    privacy_contact_text: "For any questions regarding data protection, contact us at info@kleos-ai.gr"
  }
};

export default translations;
